import IdpApprovalList from './model';
import create from './create';

IdpApprovalList.create = create;

export default IdpApprovalList;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpApprovalList/index.js